module.exports = __webpack_public_path__ + "img/6.c9622e2c.jpg";